import { render, staticRenderFns } from "./ViqMessageLoading.vue?vue&type=template&id=cd9a6812&scoped=true"
import script from "./ViqMessageLoading.vue?vue&type=script&lang=js"
export * from "./ViqMessageLoading.vue?vue&type=script&lang=js"
import style0 from "./ViqMessageLoading.vue?vue&type=style&index=0&id=cd9a6812&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9a6812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd9a6812')) {
      api.createRecord('cd9a6812', component.options)
    } else {
      api.reload('cd9a6812', component.options)
    }
    module.hot.accept("./ViqMessageLoading.vue?vue&type=template&id=cd9a6812&scoped=true", function () {
      api.rerender('cd9a6812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqMessageLoading.vue"
export default component.exports